export default __webpack_public_path__ + "static/media/logo.3ee000a7.svg";